import styled from "styled-components";
import { Scrollable } from "../../../../../common/styles";

export const ApplicationEditorModalContainer = styled.div`
  width: 727px;
  max-height: 60vh;
  ${Scrollable}
  padding-right: 20px;
  padding-bottom: 25px;
  box-sizing: border-box;
  position: relative;
  border-bottom: 1px solid #33333330;
  @media (max-width: 991px) {
    width: 100%;
    height: calc(100vh - 340px);
  }
`;
